import styles from "./NavBar.module.css";
import { NavBarProps } from "../../types";
import { NavigateFunction, useNavigate } from "react-router-dom";
import Button from "../util/Button";
import useWindowDimensions from "../util/useWindowDimensions";

const tabs = [
  "",
  "vita",
  "ausstellungen",
  "statement",
  "aktuelles",
  "kontakt",
  "impressum",
  "datenschutz",
];

const NavBar = ({ selectedTab, onTabChange }: NavBarProps) => {
  const navigate: NavigateFunction = useNavigate();
  const { width } = useWindowDimensions();
  const handleTabChange = (tab: number) => {
    if (selectedTab === tab) {
      onTabChange(0);
      navigate("/");
    } else {
      onTabChange(tab);
      navigate(`/${tabs[tab]}`);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ width: width - 20 }} className={styles.wrapper}>
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={0}
          text={"Arbeiten"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={3}
          text={"Statement"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={4}
          text={"Aktuelles"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={2}
          text={"Ausstellungen"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={1}
          text={"Vita"}
        />

        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={5}
          text={"Kontakt"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={6}
          text={"Impressum"}
        />
        <Button
          selectedTab={selectedTab}
          onTabChange={handleTabChange}
          tab={7}
          text={"Datenschutz"}
        />
      </div>
    </div>
  );
};

export default NavBar;
